import { BookingCompressedActionEnum } from './types';

export const submittedMessageMapping = {
  [BookingCompressedActionEnum.KEEP]: 'manage-closing.keep-2',
  [BookingCompressedActionEnum.DELETE]: 'manage-closing.delete',
  [BookingCompressedActionEnum.SWITCH_FROM_TO]: 'manage-closing.switched-from-to',
};
